import Vue from "vue";

import firebase from "@/firebase";

export const initialValues = {
  pool: {},
  pools: [],
  type: "Pool",
  types: ["Pool", "Hot Tub"],
  unitType: "U.S.",
  unitTypes: ["U.S.", "Metric", "Imperial"],
  length: 10,
  width: 10,
  depth: 10,
  defaultTestSetup: null,
  shape: {
    name: "Rectangular",
    multiplier: 7.48052,
  },
  shapes: [
    {
      name: "Rectangular",
      multiplier: 7.48052,
    },
    {
      name: "Oval",
      multiplier: 7.48052,
    },
    {
      name: "Round",
      multiplier: 5.87518,
    },
  ],
  volume: 7500,
  temperature: 75,
  surface: "Plaster",
  surfaces: ["Plaster", "Vinyl", "Fiberglass"],
  chlorineSource: "Bleach",
  chlorineSources: ["Bleach", "SWG", "Trichlor"],
  range: {
    name: "Traditional Pool",
    borate: { low: 30, high: 50 },
    ph: { low: 7.2, high: 7.8 },
    ta: { low: 80, high: 120 },
    ch: { low: 200, high: 400 },
    cya: { low: 30, high: 80 },
    fc: { low: 3, high: 7 },
    salt: { low: 2700, high: 3400 },
  },
  ranges: [
    {
      name: "Traditional Pool",
      borate: { low: 30, high: 50 },
      ph: { low: 7.2, high: 7.8 },
      ta: { low: 80, high: 120 },
      ch: { low: 200, high: 400 },
      cya: { low: 30, high: 80 },
      fc: { low: 3, high: 7 },
      salt: { low: 2700, high: 3400 },
    },
    {
      name: "Traditional Spa",
      borate: { low: 30, high: 50 },
      ph: { low: 7.4, high: 7.8 },
      ta: { low: 50, high: 80 },
      ch: { low: 120, high: 200 },
      cya: { low: 20, high: 40 },
      fc: { low: 1, high: 6 },
      salt: { low: 2700, high: 3400 },
    },
    {
      name: "TroubleFreePool.com",
      borate: { low: 30, high: 50 },
      ph: { low: 7.5, high: 7.8 },
      ta: { low: 100, high: 120 },
      ch: { low: 220, high: 320 },
      cya: { low: 30, high: 50 },
      fc: { low: 3, high: 7 },
      salt: { low: 2700, high: 3400 },
    },
  ],
};

export default {
  namespaced: true,
  state: { ...initialValues },
  getters: {
    getSettings(state) {
      return state;
    },
  },
  mutations: {
    setSettings(state, settings) {
      console.log("setSettings", settings);
      if (!settings) {
        return;
      }
      state.pool = settings.pool || state.pool;
      state.type = settings.type || state.type;
      state.unitType = settings.unitType || state.unitType;
      state.length = Number(settings.length) || Number(state.length);
      state.width = Number(settings.width) || Number(state.width);
      state.depth = Number(settings.depth) || Number(state.depth);
      state.shape = settings.shape || state.shape;
      state.volume = Number(settings.volume) || Number(state.volume);
      state.temperature =
        Number(settings.temperature) || Number(state.temperature);
      state.surface = settings.surface || state.surface;
      state.chlorineSource = settings.chlorineSource || state.chlorineSource;
      state.defaultTestSetup =
        settings.defaultTestSetup || state.defaultTestSetup;
    },
    setFC(state) {
      if (state.chlorineSource === "SWG") {
        state.ranges[0].fc.low = 2;
        state.ranges[2].fc.low = 2;
      } else {
        state.ranges[0].fc.low = 3;
        state.ranges[2].fc.low = 3;
      }
    },
    setTFPCH(state) {
      if (state.surface === "Plaster") {
        state.ranges[2].ch = { low: 250, high: 350 };
      } else if (state.surface === "Vinyl") {
        state.ranges[2].ch = { low: 50, high: 300 };
      } else {
        state.ranges[2].ch = { low: 220, high: 320 };
      }
    },
    setTFPTA(state) {
      if (state.chlorineSource === "Bleach") {
        state.ranges[2].ta = { low: 70, high: 90 };
      } else if (state.chlorineSource === "SWG") {
        state.ranges[2].ta = { low: 60, high: 80 };
      } else {
        state.ranges[2].ta = { low: 100, high: 120 };
      }
    },
    setTFPCYA(state) {
      if (state.chlorineSource === "SWG") {
        state.ranges[2].cya = { low: 70, high: 80 };
      } else {
        state.ranges[2].cya = { low: 30, high: 50 };
      }
    },
    setPools(state, pools) {
      state.pools = pools;
    },
    updateSettingsPool(state, changes) {
      for (const key in changes) {
        if (Object.prototype.hasOwnProperty.call(changes, key)) {
          Vue.set(state.pool, key, changes[key]);
        }
      }
    },
    updatePool(state, payload) {
      const { id, changes } = payload;
      console.log("updatePool", id, changes, state.pools);
      state.pools = state.pools.map((x) => {
        if (x.id === id) return { ...x, ...changes };
        return x;
      });
    },
  },
  actions: {
    async initSettings(state) {
      if (!firebase.auth.currentUser) return;
      const poolsResult = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("pools")
        .get();

      const poolsData = [];
      poolsResult.forEach((pool) => {
        const data = pool.data();
        poolsData.push({ ...data, id: pool.id });
      });

      poolsData.sort((a, b) => a.name.localeCompare(b.name));
      state.commit("setPools", poolsData);

      const settings = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("settings")
        .get();
      const settingsData = settings.data();
      state.commit("setSettings", settingsData);
    },
    async saveSettings(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("settings")
        .set({
          pool: data.pool,
          type: data.type,
          unitType: data.unitType,
          length: data.length,
          width: data.width,
          depth: data.depth,
          shape: data.shape,
          volume: data.volume,
          temperature: data.temperature,
          surface: data.surface,
          chlorineSource: data.chlorineSource,
          defaultTestSetup: data.defaultTestSetup,
        });
      state.commit("setSettings", data);
    },
  },
};
